<template>
  <MeetingModule>
    <c-radio-group
      class="tw-gap-2"
      name="mail_student"
      :options="radioOptions"
      v-model="model.mail_student"
      @update:model-value="updateShareFeedbackAt"
    />

    <div
      class="tw-mt-5"
      v-if="
        model.mail_student &&
        schoolSettings.student_meeting_settings.settings.action_plan_version ===
          '1.0'
      "
    >
      <c-input
        v-model="model.mail_student_summary_text"
        name="mail_student_summary_text"
        type="textarea"
        autogrow
        label="Tekst voor 'Opmerking van leerling'"
      />
    </div>

    <div class="tw-mt-5" v-if="model.mail_student">
      <c-input
        name="mail_student_text"
        v-model="model.mail_student_text"
        type="textarea"
        autogrow
        label="Instructie-mail voor de leerling"
      />
    </div>
  </MeetingModule>
</template>

<script setup>
import { onMounted, ref, watchEffect } from "vue";
import MeetingModule from "components/meeting/modules/MeetingModule.vue";
import { useSettingsStore } from "store/modules/settingStore";
import { useMeetingStore } from "store/modules/meetingStore.js";
import { storeToRefs } from "pinia";

// Define the model
const model = defineModel({
  required: true,
  type: Object,
});
const isStepCompleted = defineModel("isStepCompleted");

// Initialize setting store
const settingStore = useSettingsStore();
const { getSchoolSettings } = settingStore;
const { schoolSettings } = storeToRefs(settingStore);

const meetingStore = useMeetingStore();
const { clearShareFeedbackAt } = meetingStore;

// Refs
const radioOptions = ref([
  {
    label: "Inschakelen",
    value: 1,
  },
  {
    label: "Uitschakelen",
    value: 0,
  },
]);

const updateShareFeedbackAt = () => {
  if (!model.value.mail_student) clearShareFeedbackAt();
};

// On model update
const modelUpdate = (value) => {
  isStepCompleted.value = value != null;
};

onMounted(async () => {
  try {
    await getSchoolSettings();
  } catch (error) {
    console.log("🚀 ~ onMounted ~ error:", error);
  }

  modelUpdate(model.value.mail_student);
});

watchEffect(() => {
  modelUpdate(model.value.mail_student);
});
</script>
